import { Component } from '@angular/core';

/**
 * Empty page component
 *
 * @export
 * @class EmptyComponent
 */
@Component({
  template: ``,
  styles: []
})
export class EmptyComponent {

}
